import { render, staticRenderFns } from "./CarbonDashboard.vue?vue&type=template&id=4b9e0473&scoped=true&"
import script from "./CarbonDashboard.vue?vue&type=script&lang=js&"
export * from "./CarbonDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CarbonDashboard.vue?vue&type=style&index=0&id=4b9e0473&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e0473",
  null
  
)

export default component.exports